'use client';

import { useDocumentInfo } from '@payloadcms/ui';
import { useState } from 'react';

import type { DocumentDataWithUsedInPages } from '@/collections/modules/_shared/populate-used-in-pages';

import './styles.scss';

const MAX_VISIBLE_ROWS = 10;

export const UsedInPages = () => {
  const { data } = useDocumentInfo();
  const documentData = data as DocumentDataWithUsedInPages | undefined;
  const pages = documentData?.usedInPages ?? [];
  const [isExpanded, setIsExpanded] = useState(false);

  if (!pages.length) return null;

  const hasOverflow = pages.length > MAX_VISIBLE_ROWS;
  const visiblePages = isExpanded ? pages : pages.slice(0, MAX_VISIBLE_ROWS);

  return (
    <div className="fv-used-in-pages">
      <span className="fv-used-in-pages__label">
        This document is used in {pages.length} {pages.length === 1 ? 'page' : 'pages'}
      </span>
      <div className="table table--appearance-condensed">
        <table cellPadding="0" cellSpacing="0">
          <thead>
            <tr>
              <th className="fv-used-in-pages__col-id">Page ID</th>
              <th>Page Paths</th>
            </tr>
          </thead>
          <tbody>
            {visiblePages.map((page) => (
              <tr key={page.id}>
                <td>
                  <a href={`/admin/collections/pages/${page.id}`} className="fv-used-in-pages__link">
                    {page.id}
                  </a>
                </td>
                <td className="fv-used-in-pages__paths">{page.paths.join(', ') || '—'}</td>
              </tr>
            ))}
            {hasOverflow && (
              <tr>
                <td colSpan={2} className="fv-used-in-pages__toggle-cell">
                  <button type="button" className="fv-used-in-pages__toggle" onClick={() => setIsExpanded((prev) => !prev)}>
                    {isExpanded ? 'Show less' : `Show ${pages.length - MAX_VISIBLE_ROWS} more`}
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsedInPages;
